import { render, staticRenderFns } from "./EpFoldableDescription.vue?vue&type=template&id=49b00a56&"
import script from "./EpFoldableDescription.vue?vue&type=script&lang=js&"
export * from "./EpFoldableDescription.vue?vue&type=script&lang=js&"
import style0 from "./EpFoldableDescription.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports